import { render } from "./ApprovalsListCardManager.vue?vue&type=template&id=09a6af58"
import script from "./ApprovalsListCardManager.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__